module.exports = __webpack_public_path__ + "img/arrow_up.4a3fdcec.svg";